import React, {Component} from "react";
import {Modal} from "react-bootstrap";
import ReactToPrint from "react-to-print";
import {toast} from "react-toastify";
import ApiConnect from "../../Utils/ApiConnect";

class ShareButton extends Component {
  constructor(props) {
    super(props);
    this.state = {
      shareBtn: false,
      smsModal: false,
      smsContact: "",
      mailModal: false,
      mailAddress: "",
      btnDisable: false,
    };
    console.log(props);
  }

  onSubmitSMS = (e) => {
    e.preventDefault();
    this.setState({ btnDisable: true });
    const Fdata = new FormData();
    Fdata.append("id", this.props.id);
    Fdata.append("contact", this.state.smsContact);
    ApiConnect({
      method: "post",
      url: "/POS/Checkout/SendSMS",
      data: Fdata,
    })
      .then((response) => {
        if (response) {
          toast.success("Message Send", {
            position: "bottom-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            draggableDirection: "y",
          });
          this.setState({ smsModal: false });
        } else if (response.data.status === 406) {
          this.setState({ formError: response.data.message });
        } else {
          toast.error(response.data.message, {
            position: "bottom-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            draggableDirection: "y",
          });
        }
      })
      .catch((error) => console.log(error));
  };
  onSubmitMail = (e) => {
    e.preventDefault();
    this.setState({ btnDisable: true });
    const Fdata = new FormData();
    Fdata.append("id", this.props.id);
    Fdata.append("contact", this.state.mailAddress);
    ApiConnect({
      method: "post",
      url: "/POS/Checkout/SendMail",
      data: Fdata,
    })
      .then((response) => {
        if (response.data.status === 201) {
          toast.success(response.data.message, {
            position: "bottom-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            draggableDirection: "y",
          });
        } else if (response.data.status === 406) {
          this.setState({ formError: response.data.message });
        } else {
          toast.error(response.data.message, {
            position: "bottom-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            draggableDirection: "y",
          });
        }
      })
      .catch((error) => console.log(error));
  };
  render() {
    return (
      <React.Fragment>
        <div className="fab fab-dir-left float-end">
          <button
            className={`btn btn-float btn-danger ${
              this.state.shareBtn ? "active" : ""
            }`}
            onClick={(e) => {
              e.preventDefault();
              this.setState({ shareBtn: !this.state.shareBtn });
            }}
          >
            {this.state.shareBtn ? (
              <span className="material-icons-outlined">close</span>
            ) : (
              <span className="material-icons-outlined">share</span>
            )}
          </button>
          <ul className="fab-buttons">
            <li>
              <ReactToPrint
                documentTitle={this.props.title}
                pageStyle={this.props.PageCss}
                copyStyles={false}
                trigger={() => {
                  return (
                    <button className="btn btn-float btn-sm btn-info">
                      <span className="material-icons-outlined">print</span>
                    </button>
                  );
                }}
                content={() => this.props.componentLoad}
              />
            </li>
            <li>
              <button
                className="btn btn-float btn-sm btn-info"
                onClick={() => this.setState({ smsModal: true })}
              >
                <span className="material-icons-outlined">sms</span>
              </button>
            </li>
            <li>
              <button
                className="btn btn-float btn-sm btn-info"
                onClick={() => this.setState({ mailModal: true })}
              >
                <span className="material-icons-outlined">mail</span>
              </button>
            </li>
          </ul>
        </div>
        <Modal
          show={this.state.smsModal}
          className="modal"
          onHide={() => this.setState({ smsModal: false })}
        >
          <Modal.Dialog>
            <Modal.Header>
              <h5 className="modal-title">Share as SMS</h5>
              <button
                type="button"
                className="btn"
                onClick={() => this.setState({ smsModal: false })}
              >
                <span>×</span>
              </button>
            </Modal.Header>

            <form onSubmit={(e) => this.onSubmitSMS(e)}>
              <Modal.Body>
                <div className="form-group">
                  <label>Mobile Number</label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="1234567890"
                    required="required"
                    value={this.state.smsContact}
                    pattern="[0-9]{10}"
                    onChange={(e) =>
                      this.setState({ smsContact: e.target.value })
                    }
                  />
                </div>
              </Modal.Body>
              <Modal.Footer>
                <button className="btn btn-label btn-success">
                  <label>
                    <span className="material-icons-outlined">send</span>
                  </label>
                  Send
                </button>
                <button
                  className="btn btn-label btn-danger"
                  onClick={() => this.setState({ smsModal: false })}
                >
                  <label>
                    <span className="material-icons-outlined">close</span>
                  </label>
                  No, cancel!
                </button>
              </Modal.Footer>
            </form>
          </Modal.Dialog>
        </Modal>

        <Modal
          show={this.state.mailModal}
          className="modal"
          onHide={() => this.setState({ mailModal: false })}
        >
          <Modal.Dialog>
            <Modal.Header>
              <h5 className="modal-title">Share as Mail</h5>
              <button
                type="button"
                className="btn"
                onClick={() => this.setState({ mailModal: false })}
              >
                <span>×</span>
              </button>
            </Modal.Header>

            <form onSubmit={(e) => this.onSubmitMail(e)}>
              <Modal.Body>
                <div className="form-group">
                  <label>Email Address</label>
                  <input
                    type="email"
                    className="form-control"
                    placeholder="example@example.com"
                    value={this.state.mailAddress}
                    required="required"
                    onChange={(e) =>
                      this.setState({ mailAddress: e.target.value })
                    }
                  />
                </div>
              </Modal.Body>
              <Modal.Footer>
                <button className="btn btn-label btn-success">
                  <label>
                    <span className="material-icons-outlined">send</span>
                  </label>
                  Send
                </button>
                <button
                  className="btn btn-label btn-danger"
                  onClick={() => this.setState({ mailModal: false })}
                >
                  <label>
                    <span className="material-icons-outlined">close</span>
                  </label>
                  No, cancel!
                </button>
              </Modal.Footer>
            </form>
          </Modal.Dialog>
        </Modal>
      </React.Fragment>
    );
  }
}
export default React.memo(ShareButton);
